import React from 'react';
import styles from './About.module.css';
import bandPhoto from '../../assets/images/band-photo.jpg'; // Ensure you have this image in the specified path
import { FaMusic, FaUsers, FaEnvelope } from 'react-icons/fa';

const About: React.FC = () => {
    return (
        <div className={styles.about}>
            <div className={styles.hero}>
                <img src={bandPhoto} alt="Mob Drama Band" className={styles.heroImage} />
                <div className={styles.heroText}>
                    <h1>About Us</h1>
                </div>
            </div>
            <div className={styles.content}>
                <p><FaUsers /> We are Mob Drama, an alternative rock band formed in Bartlett, IL in 2023 by Zach Miller, Clark Hardin, and Jack Baer. We have self-recorded and released 2 EP’s of original music and play live shows around Chicago and the surrounding suburbs.</p>
                <p><FaMusic /> We play an upbeat live rock show composed of original and cover songs, specially curated to excite and inspire audiences. Below you can find all of our original releases, live videos, social media channels, and other band related content.</p>
                <p><FaEnvelope /> Please check out our music, share with a friend, follow us on social media, and contact our email for booking inquiries! JOIN THE MOB</p>
            </div>
        </div>
    );
};

export default About;
